/** 这里是 Getters */

export default {


    /**这里下面的测试内容-项目中可删除
     * getter 类似于computed 属性
     * https://vuex.vuejs.org/zh/guide/getters.html  官网讲解
     * 1.Getter 接受 state 作为其第一个参数
     * 2.Getter 也可以接受其他 getter 作为第二个参数
     * 3.你也可以通过让 getter 返回一个函数，来实现给 getter 传参
     */
    newTestName(state, getters) {
        console.log('this is getters.js-newTestName', state, getters)
        return state.test + 'getter'
    }
}


// WEBPACK FOOTER //
// ./src/store/getters.js